import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import { ACADEMIC_YEAR, CONTEXT_NAME, ERROR_MSG } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import Swal from 'sweetalert2';
import Sweetalert, { InfoAlertWithBackTabDisabled } from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import moment from 'moment';
import ExamCenters from '../Posts/ExamCenters';
import { examCenterValidations } from '../../../CommonUtilities/Validations/Validations';
import TetPreview from './TetPreview';
import { FaHandPointRight, FaWindowClose } from 'react-icons/fa';
import { RiErrorWarningLine } from "react-icons/ri";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { IoMdCheckboxOutline } from 'react-icons/io';
import { GiTakeMyMoney } from "react-icons/gi";
import { BasicDetails } from '../ChangeMobileNo';
import { set } from 'date-fns';
import { MdLockReset } from "react-icons/md";

export default function PapersApplication() {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
    //console.log("tabdetails>>", tabdetails)

    let navigate = useNavigate();
    //*************Gets Papers Api *************************** */
    const [showPosts, setShowPosts] = useState([]);
    const [hideSubmit, setHideSubmit] = useState(false)
    const [showPapersErrMsg, setPapersErrMsg] = useState("");
    function getPosts() {
        // let url = config.url.CONTEXT_URL + "tet-candidate-eligible-papers";
        let url = config.url.CONTEXT_URL + "candidate-eligible-posts";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                let data = res?.data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                let filterdata_len = data?.filter((val) => val.is_applied !== false)?.length
                if (filterdata_len === data?.length) {
                    setHideSubmit(true)
                }

                setShowPosts(res?.data?.data);
                setPapersErrMsg("");
            }
            else {
                setShowPosts([]);
                setPapersErrMsg("Based On Your Qualifications No Eligible Papers Found");
            }
        }).catch(() => {
            setShowPosts([]);
            setPapersErrMsg("Something went wrong. Please try again later.");
        });
    }
    useEffect(() => { getPosts(); }, [])

    // *****************resend otp **********************************
    const [showResendOtp, setResendOtp] = useState(false);
    const [showOtpBtn, setOtpBtn] = useState(true);
    function sendTetOtp() {
        Swal.fire({
            title: 'Are you Sure Want to Submit?',
            html: `Make Sure , OTP will be Send to your Mobile No. <b style="color: chocolate;">${loginreducer?.mobile_no}</b>`, icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send OTP",
        }).then((res) => {
            if (res.isConfirmed) {
                let otpUrl = config.url.CONTEXT_URL + "generate-tet-apply-otp"
                CommonAxiosPost(otpUrl).then((rres) => {
                    if (rres?.data?.status === true) {
                        setShowOtp(true)
                        setOtpBtn(false)
                        setTimer(180);
                        setResendOtp(false);
                    }
                    // else if (rres?.data?.scode === '03') {
                    //     Sweetalert(rres?.data?.sdesc, "warning")

                    // }
                    else {
                        Sweetalert(rres?.data?.sdesc, "warning")
                        //Sweetalert('Internal Server Issue', "warning")
                    }

                })
            }
        })
    }
    // ***********timer *******************************
    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer > 0) {
                        if (prevTimer < 122) {
                            setResendOtp(true);
                            return prevTimer - 1;
                        } else if (prevTimer > 1) {
                            return prevTimer - 1;
                        }
                        else {
                            clearInterval(interval);
                            setResendOtp(true); // Enable resend button when timer reaches 0
                            return 0;
                        }
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showOtpBtn]);

    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const resendTetOTP = () => {
        Formik.setFieldValue("otp", "")
        sendTetOtp()};
    //******************validations **************************
    let userValidations = Yup.object().shape({
        paperDetails: Yup.array()
            .of(
                Yup.object().shape({
                    tetPaperId: Yup.string().required("Paper is required"),

                })
            ).min(1, "Please select at least one post"),
        ...examCenterValidations.fields,
        papersSelfCheck1: Yup.boolean().oneOf([true], ERROR_MSG).nullable(),
        papersSelfCheck2: Yup.boolean().oneOf([true], ERROR_MSG).nullable(),
    })
    // ***********************formik **************************
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            payment: 0,
            paperDetails: [],
            option1: "",
            option2: "",
            option3: "",
            option4: "",
            option5: "",
            otp: '',
            papersSelfCheck1: false,
            papersSelfCheck2: false,
        },
        validationSchema: userValidations,
        onSubmit: (values) => {
            const invalid = values.paperDetails.find(
                (p) => !p.pref1 || !p.pref2 || !p.pref3
            );

            if (invalid) {
                Swal.fire({
                    icon: "warning",
                    title: "Missing Preferences",
                    text: "Please select Preference 1, Preference 2 and Preference 3 for all selected posts."
                });
                return;
            }
            sendTetOtp();
        }
    })
    // *************papers amount logic **********************
    const [selectedPapersCount, setSelectedPapersCount] = useState(0);
    const [previousPostCount, setPreviousPostCount] = useState(0);
    const [AlPaidPostCount, setAlPaidPost] = useState(0)
    const [getDistricts, setDistricts] = useState([])
    function PreviousCountFunction() {
        let linkurl = config.url.CONTEXT_URL + 'tet-candidate-balance-posts'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data.status === true) {
                setAlPaidPost(response?.data?.data[0]?.alr_paid_posts);
                setPreviousPostCount(response?.data?.data[0]?.balance_pay)
            }
            else {
                setAlPaidPost(0);
                setPreviousPostCount(0);
            }
        })
    }

    function districts() {
        let linkurl = config.url.CONTEXT_URL + 'aptransco-public/districts'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data.status === true) {
                setDistricts(response?.data?.districts)
            }
            else {
                setDistricts([])
            }
        })
    }



    useEffect(() => {

        // console.log("cc>>", Formik?.values?.paperDetails)
        const count = Formik?.values?.paperDetails?.filter((val) => val?.tetPaperId !== "").length || 0;
        if (count > 0) {
            setSelectedPapersCount(count);
            let amount = (count - parseInt(previousPostCount)) * 1000 * 0
            Formik.setFieldValue('payment', amount > 0 ? amount : 0)
        }
        else {
            setSelectedPapersCount(0)
        }

    }, [Formik?.values])




    // ******************post api ****************************

    const [showOtp, setShowOtp] = useState(false)
    async function postTetDataFun() {
        const values = Formik?.values;

        const eligiblePapers = values?.paperDetails.filter(paper => {
            const matched = showPosts?.find(sp => sp.tet_paper_id === paper.tetPaperId);
            return !matched?.is_applied; // include only papers not already applied
        });

        if (eligiblePapers?.length === 0) {
            Sweetalert("You have already applied for all selected papers. Please select new papers to continue.", "warning");
            return;
        }

        const postValues = {
            payment: values?.payment,
            paperDetails: eligiblePapers,
            option1: values?.option1,
            option2: values?.option2,
            option3: values?.option3,
            option4: values?.option4,
            option5: values?.option5,
            otp: values?.otp,
        };
        // console.log("vv>>", postValues)
        if (showOtp === true && values?.otp !== "") {
            const url = config.url.CONTEXT_URL + "tet-candidate-paper-details";

            Swal.fire({
                title: "Are you Sure?",
                html: `You have selected <b style="color: blue;">${postValues?.paperDetails?.length}</b> post(s)
            ${postValues?.payment > 0 ? `${previousPostCount > 0 ? `,<br/>You have already paid for<b style="color: blue;"> ${previousPostCount} </b>paper(s)` : ''}<br/>
            Now you need to pay <b style="color: green;">${postValues?.payment} Rs.</b> for
            <b style="color: blue;">${postValues?.paperDetails?.length - previousPostCount} </b> post(s)` : ""}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: postValues?.payment > 0 ? "Proceed to Pay" : "Submit",
            }).then(async (res) => {
                if (res.isConfirmed) {
                    try {
                        const response = await CommonAxiosPost(url, postValues);

                        if (response?.data?.status === true) {
                            getExamDataFunction();

                            if (postValues?.payment > 0) {
                                const link = response?.data?.paymentUrl;
                                window.open(link, "_self");
                            } else {
                                Swal.fire({
                                    title: "Successfully Submitted",
                                    icon: "success",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "OK",
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        navigate("/TetPrintApplication");
                                        window.location.reload();
                                    } else if (res.dismiss === Swal.DismissReason.cancel) {
                                        window.location.reload();
                                    }
                                });
                            }
                        } else {
                            Sweetalert(response?.data?.sdesc, "error");
                            Formik.setFieldValue("otp", "");
                        }
                    } catch (error) {
                        console.error("Error while posting data:", error);
                        Sweetalert("Something went wrong while submitting.", "error");
                        Formik.setFieldValue("otp", "");
                    }
                }
            });
        } else {
            Sweetalert("Please Enter OTP to continue", "warning");
        }
    }


    // ****************************paper-I-A and Paper-I-B logic ---------------------------------
    const [examCenterData, setExamCenterData] = useState([])
    const getExamDataFunction = () => {
        let examsUrl = config.url.CONTEXT_URL + "candidate-exam-center-details";
        CommonAxiosGet(examsUrl).then((response) => {
            if (response?.data.status === true) {
                let data = response.data.data
                setExamCenterData(response.data.data)
                Formik?.setFieldValue('option1', data[0]?.dist_code)
                Formik?.setFieldValue('option2', data[1]?.dist_code)
                Formik?.setFieldValue('option3', data[2]?.dist_code)
                Formik?.setFieldValue('option4', data[3]?.dist_code)
                Formik?.setFieldValue('option5', data[4]?.dist_code)

            }
            else {
                setExamCenterData([])
            }
        });
    };
    const zones = [
        { value: "zone1", label: "Zone 1" },
        { value: "zone2", label: "Zone 2" },
        { value: "zone3", label: "Zone 3" }
    ];


    useEffect(() => {
        getExamDataFunction();
        PreviousCountFunction();
        districts();
    }, [])
    const handleClose = () => setShow(false);
    const [show, setShow] = useState(() => {
        if (tabdetails?.latestTab === 3) {
            return tabdetails?.confirm === false;
        }
        return '';
    });
    const points = [
        "I hereby declare that I have read and understood the notification, and that all the information provided above is true and correct to the best of my knowledge.",
        "English is compulsory language as Language-II. The total question paper shall be in Language-I (selected in papers details) followed by English (Language-II)."
    ];
    return (
        <React.Fragment>
            <div className='pop pop-fix'>
                {show && <div className="background-hide"></div>}
                <Modal size="xl" className='pop pop-fix' show={show} onHide={() => { handleClose(); navigate(-1) }} backdrop="static"
                    style={{ maxWidth: '100%', width: '100%' }}
                >
                    <Modal.Header style={{}} >
                        <Modal.Title>  {CONTEXT_NAME}</Modal.Title>
                        <div className='text-end'>
                        <button type="button" className='btn btn-end'
                            onClick={() => {
                                setShow(false);
                                navigate(-1)
                            }} style={{ fadeType: "out" }}
                            variant="danger"
                            aria-label="Close"><h4>
                                <FaWindowClose className="text-danger" size={32} />
                            </h4></button>
                            </div>
                    </Modal.Header>
                    <Modal.Body>
                        <TetPreview handleClose={handleClose} />
                    </Modal.Body>
                </Modal></div>
            <CommonPageHeading heading={`${CONTEXT_NAME} ${ACADEMIC_YEAR} Post Details`} />
            {tabdetails?.confirm ? <>
                {showPapersErrMsg ? <div className="text-center text-danger fw-bold mt-3">
                    {showPapersErrMsg}
                </div> : (<>
                    <BasicDetails loginreducer={loginreducer} />

                    <FormikProvider value={Formik}>
                        <Form className="form-section" onSubmit={Formik.handleSubmit}>
                            <div className='px-4 mt-4'>

                                <div className="personal-head ">
                                    <span>Posts Details</span>
                                </div>
                                <div className="personal-row pb-3">
                                    <Row className="px-3">
                                        <div className="table-responsive">
                                            <div className='px-4 mt-4'>
                                                <Row>

                                                    <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} className=''>
                                                        <div className='mb-2'>
                                                            <FaHandPointRight size={30} />&emsp;

                                                            <OverlayTrigger placement="top-start"
                                                                overlay={
                                                                    <Tooltip id="note-tooltip" className="custom-tooltip">
                                                                        <strong>1. How to choose language–I of APTET Paper-I:</strong><br />
                                                                        The following languages are offered under First Language in the Schools under the State Syllabus viz.,
                                                                        Telugu, Urdu, Hindi, Kannada, Tamil and Odiya. A candidate has to choose one of these six (6) languages under
                                                                        Language-I for AP TET; those candidates shall have compulsorily studied that language either as medium of study
                                                                        or as First Language up to class X.<br />
                                                                        <strong>2. English is compulsory language for all candidates as Language-II.</strong>
                                                                    </Tooltip>
                                                                }
                                                                popperConfig={{
                                                                    modifiers: [
                                                                        {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [50, 5] // [skewRight, down], adjust numbers as needed
                                                                            },
                                                                        },
                                                                    ],
                                                                }}
                                                            >
                                                                <i
                                                                    style={{ background: "#2a9d8f", cursor: "pointer" }}
                                                                    className="badge badge-success forgot fw-bold"
                                                                >
                                                                    Read Me <RiErrorWarningLine style={{ fontSize: '22px' }} />
                                                                </i>
                                                            </OverlayTrigger>

                                                        </div>
                                                    </Col>

                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={12} xs={12}>

                                                        <div className='alert alert-info'>
                                                            <h6> <span style={{ fontFamily: 'bold' }} className='text-danger'>NOTE : </span>
                                                                <ul>
                                                                    <li>
                                                                        It is highly recommended to complete payments using a <strong>laptop or desktop</strong>, as mobile devices may experience technical issues during the process.
                                                                    </li>
                                                                    {AlPaidPostCount > 0 && (<li>
                                                                        You have made payment for&nbsp;
                                                                        <span style={{ color: 'red', fontFamily: 'bold' }}>{AlPaidPostCount}</span> no. of paper(s) earlier,please select below
                                                                        eligible paper(s).
                                                                    </li>)}
                                                                </ul>
                                                            </h6>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {(() => {
                                                if (showPapersErrMsg) {
                                                    return (
                                                        <div className="text-center text-danger fw-bold mt-3">
                                                            {showPapersErrMsg}
                                                        </div>
                                                    );
                                                }

                                                // Single table with all posts
                                                // const renderTable = (papers) => (

                                                //     <table
                                                //         className="table table-condensed table-bordered mb-3"
                                                //         style={{ borderCollapse: "collapse", width: "100%" }}
                                                //     >
                                                //         <thead className="tetpapers-table-head">
                                                //             <tr>
                                                //                 <th>Choose Post</th>
                                                //                 <th>Preference 1</th>
                                                //                 <th>Preference 2</th>
                                                //                 <th>Preference 3</th>

                                                //             </tr>
                                                //         </thead>

                                                //         <tbody className="tetpapers-table fw-sm">
                                                //             {papers?.map((paper) => {

                                                //                 const isChecked = Formik.values.paperDetails?.some(
                                                //                     (p) => p.tetPaperId === paper.post_id
                                                //                 );

                                                //                 const paperIndex = Formik.values.paperDetails.findIndex(
                                                //                     (p) => p.tetPaperId === paper.post_id
                                                //                 );

                                                //                 return (
                                                //                     <tr key={paper.post_id}>

                                                //                         {/* Post Checkbox */}
                                                //                         <td style={{ width: "40%", fontSize: "0.85rem", lineHeight: "1.3" }}>
                                                //                             {paper.is_applied ? (
                                                //                                 <span className="d-flex align-items-center gap-2">
                                                //                                     <IoMdCheckboxOutline color="green" size={20} />
                                                //                                     <span style={{ fontWeight: 550 }}>{paper.post_name}</span>
                                                //                                 </span>
                                                //                             ) : (
                                                //                                 <Form.Check
                                                //                                     type="checkbox"
                                                //                                     id={paper.post_id}
                                                //                                     label={<span style={{ fontWeight: 550 }}>{paper.post_name}</span>}
                                                //                                     checked={isChecked}
                                                //                                     onChange={(e) => {
                                                //                                         if (paper.is_applied) return;

                                                //                                         let updated = [...Formik.values.paperDetails];

                                                //                                         if (e.target.checked) {
                                                //                                             updated.push({
                                                //                                                 tetPaperId: paper.post_id,
                                                //                                                 pref1: "",
                                                //                                                 pref2: "",
                                                //                                                 pref3: "",
                                                //                                             });
                                                //                                         } else {
                                                //                                             updated = updated.filter(
                                                //                                                 (p) => p.tetPaperId !== paper.post_id
                                                //                                             );
                                                //                                         }

                                                //                                         Formik.setFieldValue("paperDetails", updated);
                                                //                                     }}
                                                //                                 />
                                                //                             )}
                                                //                         </td>


                                                //                         <td style={{ width: "20%", fontSize: "0.90rem" }}>
                                                //                             {paper.is_applied ? (
                                                //                                 <span>{paper?.pref1}</span>
                                                //                             ) : (
                                                //                                 <>
                                                //                                     <Field
                                                //                                         as="select"
                                                //                                         className="form-control"
                                                //                                         name={`paperDetails[${paperIndex}].pref1`}
                                                //                                         disabled={!isChecked}
                                                //                                     >
                                                //                                         <option value="">Select</option>
                                                //                                         <option value="zone1">Zone 1</option>
                                                //                                         <option value="zone2">Zone 2</option>
                                                //                                         <option value="zone3">Zone 3</option>

                                                //                                     </Field>

                                                //                                     <ErrorMessage
                                                //                                         name={`paperDetails[${paperIndex}].pref1`}
                                                //                                         component="div"
                                                //                                         className="text-error"
                                                //                                     />
                                                //                                 </>
                                                //                             )}
                                                //                         </td>
                                                //                         <td style={{ width: "20%", fontSize: "0.90rem" }}>
                                                //                             {paper.is_applied ? (
                                                //                                 <span>{paper?.pref2}</span>
                                                //                             ) : (
                                                //                                 <>
                                                //                                     <Field
                                                //                                         as="select"
                                                //                                         className="form-control"
                                                //                                         name={`paperDetails[${paperIndex}].pref2`}
                                                //                                         disabled={!isChecked}
                                                //                                     >
                                                //                                         <option value="">Select</option>
                                                //                                         <option value="zone1">Zone 1</option>
                                                //                                         <option value="zone2">Zone 2</option>
                                                //                                         <option value="zone3">Zone 3</option>
                                                //                                     </Field>  <ErrorMessage
                                                //                                         name={`paperDetails[${paperIndex}].pref2`}
                                                //                                         component="div"
                                                //                                         className="text-error"
                                                //                                     />
                                                //                                 </>
                                                //                             )}
                                                //                         </td>
                                                //                         <td style={{ width: "20%", fontSize: "0.90rem" }}>
                                                //                             {paper.is_applied ? (
                                                //                                 <span>{paper?.pref3}</span>
                                                //                             ) : (
                                                //                                 <>
                                                //                                     <Field
                                                //                                         as="select"
                                                //                                         className="form-control"
                                                //                                         name={`paperDetails[${paperIndex}].pref3`}
                                                //                                         disabled={!isChecked}
                                                //                                     >
                                                //                                         <option value="">Select</option>
                                                //                                         <option value="zone1">Zone 1</option>
                                                //                                         <option value="zone2">Zone 2</option>
                                                //                                         <option value="zone3">Zone 3</option>            </Field>

                                                //                                     <ErrorMessage
                                                //                                         name={`paperDetails[${paperIndex}].pref3`}
                                                //                                         component="div"
                                                //                                         className="text-error"
                                                //                                     />
                                                //                                 </>
                                                //                             )}
                                                //                         </td>


                                                //                     </tr>
                                                //                 );
                                                //             })}
                                                //         </tbody>
                                                //     </table>
                                                // );
                                                const renderTable = (papers) => {

                                                    const zones = [
                                                        { value: "zone1", label: "Zone 1" },
                                                        { value: "zone2", label: "Zone 2" },
                                                        { value: "zone3", label: "Zone 3" }
                                                    ];

                                                    return (
                                                        <table
                                                            className="table table-condensed table-bordered mb-3"
                                                            style={{ borderCollapse: "collapse", width: "100%" }}
                                                        >
                                                            <thead className="tetpapers-table-head">
                                                                <tr>
                                                                    <th>Choose Post</th>
                                                                    <th>Preference 1</th>
                                                                    <th>Preference 2</th>
                                                                    <th>Preference 3</th>
                                                                    <th>Reset</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody className="tetpapers-table fw-sm">
                                                                {papers?.map((paper) => {

                                                                    const isChecked = Formik.values.paperDetails?.some(
                                                                        (p) => p.tetPaperId === paper.post_id
                                                                    );

                                                                    const paperIndex = Formik.values.paperDetails.findIndex(
                                                                        (p) => p.tetPaperId === paper.post_id
                                                                    );

                                                                    const selectedPaper = Formik.values.paperDetails.find(
                                                                        (p) => p.tetPaperId === paper.post_id
                                                                    );

                                                                    const pref1 = selectedPaper?.pref1 || "";
                                                                    const pref2 = selectedPaper?.pref2 || "";
                                                                    const pref3 = selectedPaper?.pref3 || "";

                                                                    const pref2Zones = zones.filter((z) => z.value !== pref1);

                                                                    const pref3Zones = zones.filter(
                                                                        (z) => z.value !== pref1 && z.value !== pref2
                                                                    );

                                                                    return (
                                                                        <tr key={paper.post_id}>

                                                                            {/* POST CHECKBOX */}
                                                                            <td style={{ width: "40%", fontSize: "0.85rem" }}>
                                                                                {paper.is_applied ? (
                                                                                    <span className="d-flex align-items-center gap-2">
                                                                                        <IoMdCheckboxOutline color="green" size={20} />
                                                                                        <span style={{ fontWeight: 550 }}>{paper.post_name}</span>
                                                                                    </span>
                                                                                ) : (
                                                                                    <Form.Check
                                                                                        type="checkbox"
                                                                                        id={paper.post_id}
                                                                                        label={<span style={{ fontWeight: 550 }}>{paper.post_name}</span>}
                                                                                        checked={isChecked}
                                                                                        onChange={(e) => {

                                                                                            let updated = [...Formik.values.paperDetails];

                                                                                            if (e.target.checked) {
                                                                                                updated.push({
                                                                                                    tetPaperId: paper.post_id,
                                                                                                    pref1: "",
                                                                                                    pref2: "",
                                                                                                    pref3: ""
                                                                                                });
                                                                                            } else {
                                                                                                updated = updated.filter(
                                                                                                    (p) => p.tetPaperId !== paper.post_id
                                                                                                );
                                                                                            }

                                                                                            Formik.setFieldValue("paperDetails", updated);
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </td>


                                                                            <td style={{ width: "20%" }}>
                                                                                {paper.is_applied ? (
                                                                                    <span>{paper?.pref1}</span>
                                                                                ) : (

                                                                                    <>
                                                                                        <Form.Select
                                                                                            disabled={!isChecked}
                                                                                            value={pref1}
                                                                                            onChange={(e) => {

                                                                                                const updated = Formik.values.paperDetails.map((p) =>
                                                                                                    p.tetPaperId === paper.post_id
                                                                                                        ? { ...p, pref1: e.target.value, pref2: "", pref3: "" }
                                                                                                        : p
                                                                                                );

                                                                                                Formik.setFieldValue("paperDetails", updated);
                                                                                            }}
                                                                                        >
                                                                                            <option value="">Select</option>
                                                                                            {zones.map((z) => (
                                                                                                <option key={z.value} value={z.value}>
                                                                                                    {z.label}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Form.Select>
                                                                                        <ErrorMessage
                                                                                            name={`paperDetails[${paperIndex}].pref1`}
                                                                                            component="div"
                                                                                            className="text-error"
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                            </td>



                                                                            <td style={{ width: "20%" }}>
                                                                                {paper.is_applied ? (
                                                                                    <span>{paper?.pref2}</span>
                                                                                ) : (

                                                                                    <>
                                                                                        <Form.Select
                                                                                            disabled={!isChecked}
                                                                                            value={pref2}
                                                                                            onChange={(e) => {

                                                                                                const updated = Formik.values.paperDetails.map((p) =>
                                                                                                    p.tetPaperId === paper.post_id
                                                                                                        ? { ...p, pref2: e.target.value, pref3: "" }
                                                                                                        : p
                                                                                                );

                                                                                                Formik.setFieldValue("paperDetails", updated);
                                                                                            }}
                                                                                        >
                                                                                            <option value="">Select</option>
                                                                                            {pref2Zones.map((z) => (
                                                                                                <option key={z.value} value={z.value}>
                                                                                                    {z.label}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Form.Select>
                                                                                        <ErrorMessage
                                                                                            name={`paperDetails[${paperIndex}].pref2`}
                                                                                            component="div"
                                                                                            className="text-error"
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                            </td>


                                                                            {/* PREF3 */}
                                                                            <td style={{ width: "20%" }}>
                                                                                {paper.is_applied ? (
                                                                                    <span>{paper?.pref2}</span>
                                                                                ) : (

                                                                                    <>
                                                                                        <Form.Select
                                                                                            disabled={!isChecked}
                                                                                            value={pref3}
                                                                                            onChange={(e) => {

                                                                                                const updated = Formik.values.paperDetails.map((p) =>
                                                                                                    p.tetPaperId === paper.post_id
                                                                                                        ? { ...p, pref3: e.target.value }
                                                                                                        : p
                                                                                                );

                                                                                                Formik.setFieldValue("paperDetails", updated);
                                                                                            }}
                                                                                        >
                                                                                            <option value="">Select</option>
                                                                                            {pref3Zones.map((z) => (
                                                                                                <option key={z.value} value={z.value}>
                                                                                                    {z.label}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Form.Select>


                                                                                        <ErrorMessage
                                                                                            name={`paperDetails[${paperIndex}].pref3`}
                                                                                            component="div"
                                                                                            className="text-error"
                                                                                        />
                                                                                    </>
                                                                                )}

                                                                            </td>
                                                                            {/* <td>
                                                                                <Button className="submit-btn btn-success" type='button' onClick={() =>
                                                                                     {  }} style={{ textDecorationLine: 'underline' }}> <MdLockReset size={17} /> </Button>
                                                                                </td> */}
                                                                            <td>
                                                                                <Button
                                                                                    className="submit-btn btn-success"
                                                                                    type="button"
                                                                                    disabled={!isChecked}
                                                                                    style={{ textDecorationLine: "underline" }}
                                                                                    onClick={() => {

                                                                                        const updated = Formik.values.paperDetails.map((p) =>
                                                                                            p.tetPaperId === paper.post_id
                                                                                                ? { ...p, pref1: "", pref2: "", pref3: "" }
                                                                                                : p
                                                                                        );

                                                                                        Formik.setFieldValue("paperDetails", updated);

                                                                                    }}
                                                                                >
                                                                                    <MdLockReset size={17} />
                                                                                </Button>
                                                                            </td>

                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    );
                                                };

                                                return (
                                                    <div>
                                                        {showPosts.length > 0 && renderTable(showPosts)}
                                                    </div>
                                                );
                                            })()}
                                            {selectedPapersCount > 0 &&
                                                <Row><Col md={12} className='text-center'>
                                                    <div className='alert alert-success'>
                                                        {(previousPostCount > 0 && (parseInt(AlPaidPostCount) - parseInt(previousPostCount) > 0)) ?
                                                            <> You have already applied for {AlPaidPostCount - previousPostCount} paper(s).&nbsp;</>
                                                            : ''}
                                                        {selectedPapersCount > 0 && (<> you are now applying for {selectedPapersCount}&nbsp;post(s)<span style={{ color: "green" }}>
                                                            &nbsp; ({parseInt(selectedPapersCount) * 1000} Rs.) </span>
                                                        </>)}
                                                        <pre />
                                                        {(parseInt(selectedPapersCount) - parseInt(previousPostCount)) > 0 ? (<>
                                                            You have to Pay an amount of  <span style={{ color: "green" }}>&nbsp;
                                                                {(parseInt(selectedPapersCount) - parseInt(previousPostCount)) * 1000} Rs. </span> &nbsp;
                                                            <span className='blink-color'
                                                            > PAYMENT</span>

                                                        </>) :
                                                            (<>
                                                                {(parseInt(previousPostCount) - parseInt(selectedPapersCount)) > 0 && (<>
                                                                    Balance Amount   : <span style={{ color: "green" }}>&nbsp;
                                                                        {(parseInt(previousPostCount) - parseInt(selectedPapersCount)) * 1000}  Rs.</span> &nbsp;
                                                                </>)}
                                                            </>)

                                                        }

                                                    </div>
                                                </Col></Row>}


                                        </div>
                                        <ErrorMessage name="paperDetails" component="div" className="text-error" />
                                    </Row>
                                </div>

                                <ExamCenters Formik={Formik} Data={examCenterData} />

                                <Row className="pb-0 pt-2 mx-0">
                                    <Col xs={12} className="alert alert-warning">
                                        {points.map((text, index) => {
                                            const fieldName = `papersSelfCheck${index + 1}`;
                                            return (
                                                <div key={index} className={`${index > 0 ? 'mt-2' : ''}`}>
                                                    <div className="d-flex align-items-center">
                                                        {!hideSubmit ? (
                                                            <Field type="checkbox" name={fieldName} className="form-sub me-2"
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;
                                                                    Formik.setFieldValue(fieldName, isChecked ? true : null);
                                                                }}
                                                            />
                                                        ) : (
                                                            <IoMdCheckboxOutline color="green" size={20} className="me-2" />
                                                        )}
                                                        <span>{text}</span>
                                                    </div>

                                                    {!hideSubmit && (
                                                        <ErrorMessage name={fieldName} component="div" className="text-error mt-1" />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </Col>
                                </Row>
                                {hideSubmit === false &&
                                    <Row className='pb-4'>
                                        {showOtp === true &&
                                            <React.Fragment>
                                                <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3}></Col>
                                                <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                                    {showResendOtp === true ? <React.Fragment>
                                                        <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>&emsp;
                                                        <Button variant="primary" type="button" className="" onClick={() => { resendTetOTP() }}>Resend OTP </Button>
                                                    </React.Fragment>
                                                        : ''}
                                                </Col>
                                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                                    <React.Fragment>
                                                        <p>
                                                            Time Remaining:  {formatTime(timer)}
                                                        </p>
                                                    </React.Fragment>
                                                </Col>
                                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                                    <Form.Group controlId="otp">
                                                        <Field type="text" name="otp" className="input-field form-control" placeholder="Enter OTP" maxLength={6} />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                                    <div className='float-end'>
                                                        <Button variant="success" type="button" className="submit-btn btn-success"
                                                            onClick={() => { postTetDataFun() }}
                                                        >
                                                            {Formik?.values?.payment > 0 ? 'Proceed to Pay & Submit' : 'Submit'}
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </React.Fragment>}
                                        {showOtp === false && <React.Fragment>
                                            <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}></Col>
                                            <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-2'>
                                                <div className='float-end'><Button variant="primary" type="submit" className="submit-btn btn-primary">  Generate OTP </Button></div>
                                            </Col>
                                        </React.Fragment>}
                                    </Row>
                                }


                            </div>
                        </Form>
                    </FormikProvider>
                </>)}
            </> :
                <div>   <h3 className="text-error mt-4 border p-3 fs-6 w-100">
                    <strong>Dear {loginreducer?.applicant_name},</strong><pre />
                    Your Application is Partially Submitted for {CONTEXT_NAME}-{ACADEMIC_YEAR} , Please Complete the Application to View Papers.
                    <span>  <i style={{ background: "#2a9d8f" }}
                        className="badge badge-success forgot fw-bold"
                        onClick={() => navigate('/ProfileDetailsWay')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                navigate('/ProfileDetailsWay')
                            }
                        }}
                        data-toggle="tooltip" animation="true"
                    > Click Here </i> </span> to complete the application.

                </h3></div>}
        </React.Fragment>
    )
}
